import { render, staticRenderFns } from "./Home3.vue?vue&type=template&id=cc4227ec&scoped=true&"
import script from "./Home3.vue?vue&type=script&lang=js&"
export * from "./Home3.vue?vue&type=script&lang=js&"
import style0 from "./Home3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Home3.vue?vue&type=style&index=1&id=cc4227ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4227ec",
  null
  
)

export default component.exports